import Descriptor from '@r6digital/rapidstor-types/react/entities/Descriptor';
import Location from '@r6digital/rapidstor-types/react/entities/Location';
import UnitType from '@r6digital/rapidstor-types/react/entities/UnitType';
import { createSlice } from '@reduxjs/toolkit';

import { RootState } from './index';

export interface UnitData {
    location: Location;
    unitType: UnitType;
    descriptor: Descriptor;
    reservation: boolean;
}

interface State {
    unitData: UnitData | null;
    storageType: string | null;
    storageSize: number | null;
    location: Location | null;
    personaId: string | null;
    isAshford: boolean;
}

const initialState: State = {
    unitData: null,
    storageType: null,
    storageSize: null,
    location: null,
    personaId: null,
    isAshford: false,
};

export const bookingSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        setUnitData: (state, action: { payload: UnitData; type: string }) => {
            state.unitData = action.payload;
        },
        setStorageType: (state, action: { payload: string | null; type: string }) => {
            state.storageType = action.payload;
        },
        setStorageSize: (state, action: { payload: number | null; type: string }) => {
            state.storageSize = action.payload;
        },
        setLocation: (state, action: { payload: Location; type: string }) => {
            state.location = action.payload;
        },
        setPersonaId: (state, action: { payload: string | null; type: string }) => {
            state.personaId = action.payload;
        },
        setIsAshford: (state, action: { payload: boolean; type: string }) => {
            state.isAshford = action.payload;
        },
    },
});

export const {
    setUnitData,
    setStorageType,
    setStorageSize,
    setLocation,
    setPersonaId,
    setIsAshford,
} = bookingSlice.actions;

export const selectUnitData = (state: RootState) => state.booking.unitData;
export const selectStorageType = (state: RootState) => state.booking.storageType;
export const selectStorageSize = (state: RootState) => state.booking.storageSize;
export const selectLocation = (state: RootState) => state.booking.location;
export const selectPersonaId = (state: RootState) => state.booking.personaId;
export const selectIsAshford = (state: RootState) => state.booking.isAshford;
